// SPDX-FileCopyrightText: Copyright (C) 2026 provide.io llc
// SPDX-License-Identifier: Apache-2.0
import type { ReactElement } from "react";
import { useAuth } from "react-oidc-context";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function UserMenu(): ReactElement | null {
  const auth = useAuth();
  // When auth is disabled in config.json, AuthProvider is not mounted and
  // useAuth() returns undefined. Render nothing in that case.
  if (!auth) return null;
  if (!auth.isAuthenticated) {
    return (
      <Button size="sm" onClick={() => auth.signinRedirect()}>
        Sign in
      </Button>
    );
  }
  const name = auth.user?.profile.preferred_username ?? auth.user?.profile.sub ?? "user";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm">
          {name}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => auth.signoutRedirect()}>Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
